import { Pipe, PipeTransform } from '@angular/core';

/** INR shows whole rupees unless the amount includes paise; other currencies keep 2 decimals. */
export function formatDutyfreeCurrency(
  value: number | string | null | undefined,
  currencyCode: string = 'INR',
  locale?: string
): string {
  if (value == null || value === '') {
    return '';
  }
  const amount = Number(value);
  if (!Number.isFinite(amount)) {
    return '';
  }
  const code = String(currencyCode || 'INR').trim().toUpperCase() || 'INR';
  const fractionDigits =
    code === 'INR' ? (Math.round(amount * 100) % 100 === 0 ? 0 : 2) : 2;
  const options: Intl.NumberFormatOptions = {
    style: 'currency',
    currency: code,
    currencyDisplay: 'narrowSymbol',
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  };
  try {
    return new Intl.NumberFormat(locale || undefined, options).format(amount);
  } catch {
    try {
      const { currencyDisplay: _narrow, ...fallback } = options;
      return new Intl.NumberFormat(locale || undefined, fallback).format(amount);
    } catch {
      const rounded =
        fractionDigits === 0 ? Math.round(amount) : amount.toFixed(2);
      return `${code} ${rounded}`;
    }
  }
}

@Pipe({
  name: 'dfCurrency',
})
export class DutyfreeCurrencyPipe implements PipeTransform {
  transform(
    value: number | string | null | undefined,
    currencyCode: string = 'INR'
  ): string {
    return formatDutyfreeCurrency(value, currencyCode);
  }
}
